var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{attrs:{"id":"layout-main"}},[_c('sidebar'),_c('a-layout',[_c('navbar'),_c('a-layout-content',{style:({ margin: '12px 12px', padding: 0, background: '#fff', minHeight: '280px', flex: 'none' })},[_c('app-content')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }